import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { OutlookMockup } from "@/components/marketing/OutlookMockup";
import { DotGrid } from "@/components/marketing/DotGrid";
import { SplineBackground } from "@/components/marketing/SplineBackground";

export const Hero = () => {
  return (
    <section className="dark relative isolate overflow-visible bg-[hsl(230_45%_6%)] text-foreground -mt-24 pt-32 md:pt-36 pb-16 md:pb-28 min-h-[80vh] md:min-h-[85vh] flex items-center">
      <SplineBackground />
      <DotGrid fade="radial" />
      <div className="relative z-10 w-full">
      <div className="container relative px-4">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left content */}
          <div className="text-center md:text-left">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground/5 border border-foreground/15 backdrop-blur-md">
              <span className="w-1.5 h-1.5 rounded-full bg-success shadow-[0_0_8px_hsl(var(--success))]" />
              <span className="text-[11px] font-mono uppercase tracking-wider text-foreground/80">
                Available on Microsoft AppSource
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-display font-bold text-3xl sm:text-5xl lg:text-[3.5rem] xl:text-6xl leading-[1.05] mt-5 sm:mt-6 text-foreground">
              Turn email signatures into{" "}
              <span className="text-primary">structured Outlook contacts</span>
            </h1>

            {/* Sub-copy */}
            <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-xl mx-auto md:mx-0 leading-relaxed">
              Email2Contact reads any email in Outlook, extracts the signature, and saves a complete
              contact in one click. No new tool to learn — works inside Microsoft Outlook.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
              <Button size="lg" asChild className="shadow-fluent-8 group">
                <a
                  href="https://marketplace.microsoft.com/en-us/product/WA200010021?tab=Overview"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  Get the Add-in
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </a>
              </Button>
              <Button size="lg" variant="outline" asChild>
                <Link to="/pricing">View plans</Link>
              </Button>
            </div>

            {/* Compatibility row */}
            <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 justify-center md:justify-start text-xs text-muted-foreground font-mono uppercase tracking-wider">
              <span className="inline-flex items-center gap-1.5">
                <Check className="w-3 h-3 text-success" /> Outlook Web
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Check className="w-3 h-3 text-success" /> Desktop
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Check className="w-3 h-3 text-success" /> Mac
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Check className="w-3 h-3 text-success" /> EU-hosted AI
              </span>
            </div>
          </div>

          {/* Right: product mockup */}
          <div className="relative">
            <OutlookMockup />
          </div>
        </div>
      </div>
      </div>
      {/* Bottom fade — blends dark hero into page background (works in both light & dark) */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-24 md:h-32 z-20 bg-gradient-to-b from-transparent to-background"
      />
    </section>
  );
};
